/**
 * Up to two initials for an entity title, shown wherever the entity has no picture. Shared by the
 * canvas node and its minimap counterpart so the two always read the same.
 */
export const getInitials = (name: string): string =>
	name
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((word: string) => word[0]?.toUpperCase() ?? "")
		.join("") || "?";
